export const FONT = {
    FAMILY: 'Arial, Helvetica, sans-serif',
    FAMILY_SECOND: 'DINCondensedRegular, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 400,
    WEIGHT_BOLD: 700,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 13,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const COLOR = {
    BASE: {
        PAGE: '#ebebeb',
        DIVIDER: '#e4e5e7',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#ffffff',
        BACKGROUND2: '#cccccc',
        BACKGROUND3: '#ffffff',
        BACKGROUND4: '#343744',
        BACKGROUND5: '#2c2e39',
        BACKGROUND6: '#d81921',
        BACKGROUND7: '#aa0000',
        FOREGROUND1: '#000000',
        FOREGROUND2: '#333333',
        FOREGROUND3: '#636363',
        FOREGROUND4: '#f7f7f7',
        FOREGROUND5: '#ffffff',
        FOREGROUND6: '#ffffff',
        FOREGROUND6_1: '#cccccc',
        FOREGROUND7: '#aa0000',
        ACCENT1: '#d81921',
        ACCENT2: '#739a00',
        ACCENT3: '#7c080b',
        CTA1: 'linear-gradient(to bottom, #9ebe42, #739a00)',
        CTA2: '#d81921',
    },
    SEMANTIC: {
        ERROR1: '#fb4444',
        ERROR2: '#ffd8d8',
        WARNING1: '#fbe044',
        WARNING2: '#fdf3b7',
        SUCCESS1: '#00ba91',
        SUCCESS2: '#bfebe1',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
        ACCENT: '#5990e2',
    },
    HOVER: {
        SUCCESS: '#6d9200',
        ERROR: '#cd171f',
    },
};

export const BASIC_PALETTE = {
    FONT_FAMILY: 'Arial, Helvetica, sans-serif',

    FONT_HEADER4: {
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        fontSize: FONT.SIZE_MEDIUM,
        textTransform: 'uppercase',
    },
    FONT_BODY_MEDIUM: {
        fontSize: 14,
        fontWeight: 400,
    },

    DEFAULT_PAGE_BG: COLOR.BASE.PAGE,
    DEFAULT_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
    DEFAULT_HEADER_BG: COLOR.BRAND.BACKGROUND6,
    DEFAULT_ODDS_BG: COLOR.BRAND.BACKGROUND5,
    DEFAULT_ODDS_SELECTED_BG: COLOR.BRAND.ACCENT2,
    DEFAULT_PROMO_CARD_BG: COLOR.BRAND.BACKGROUND1,
    DEFAULT_SHEET_BG: COLOR.BRAND.BACKGROUND1,
    DEFAULT_POPOVER_BG: COLOR.BRAND.BACKGROUND2,
    DEFAULT_SELECTION_BG: COLOR.BRAND.CTA1,
    DEFAULT_STYLIZED_BG: COLOR.BRAND.BACKGROUND5,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.RESERVED.WHITE}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND3}`,

    DEFAULT_LIVE_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_PRIMARY_BUTTON_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,

    DEFAULT_CONTROLS_BORDER_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER,

    DEFAULT_BUTTON_BORDER_RADIUS: 4,
    DEFAULT_NOTIFICATION_BORDER_RADIUS: 4,

    DEFAULT_LEAGUE_HEADER_BG: COLOR.BRAND.BACKGROUND3,
    DEFAULT_BOX_DECORATION_WITH_SHADOW: true,
};
